/***
 * @file:
 * @author: caojianping
 * @Date: 2021-03-08 09:39:45
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';

import { NzMessageService } from 'ng-zorro-antd';

import { I18NService } from '@ithinkdt/shared/i18n';
import { preventBubble } from '@ithinkdt/shared/utils';
import { ChangeAccountService } from '@ithinkdt/theme/fetch-service';
import { AccountInfo } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-pcp-theme-account',
  templateUrl: './pcp-theme-account.component.html',
  styleUrls: ['./pcp-theme-account.component.scss'],
})
export class PcpThemeAccountComponent implements OnInit {
  @Input() visible = false;
  @Input() accounts: AccountInfo[] = [];

  @Output() close = new EventEmitter();
  @Output() change = new EventEmitter<AccountInfo[]>();
  @Output() refresh = new EventEmitter();

  temporaryTenantId: any;

  constructor(
    private router: Router,
    private messageSrv: NzMessageService,
    private i18nSrv: I18NService,
    private changeAccountSrv: ChangeAccountService
  ) {}

  ngOnInit() {}

  // åæ¢è´¦æ·
  toggleAccount(index: number) {
    const accounts = cloneDeep(this.accounts);
    accounts.map((item: AccountInfo, i: number) => {
      if (index === i) {
        item.selected = true;
        this.temporaryTenantId = item.tenantId;
      } else {
        item.selected = false;
      }
    });
    this.change.emit(accounts);
  }

  // è®¾ç½®é»è®¤è´¦æ·
  setDefaultAccount(data: AccountInfo, event: any) {
    this.changeAccountSrv.settingDefaultAccount({ tenantId: data.tenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.settingSuccess'));
        this.refresh.emit();
      }
    });

    // é²æ­¢åæ³¡
    preventBubble(event);
  }

  // å³é­æ¨¡ææ¡
  closeModal() {
    this.close.emit();
  }

  // ç¡®è®¤æ¨¡ææ¡
  confirmModal() {
    this.changeAccountSrv.exchangeAccount({ tenantId: this.temporaryTenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.exchangeSuccess'));
        this.close.emit();
        this.router.navigate(['/change-account'], { queryParams: { token: res.data } });
      }
    });
  }
}
